import { j as r } from "../../jsx-runtime-p91LotPX.mjs";
import { E as o } from "../../index-CXEaQcuD.mjs";
function m() {
  return /* @__PURE__ */ r.jsx(o, { image: o.PRESENTED_IMAGE_SIMPLE });
}
export {
  m as NoRowsOverlay
};
//# sourceMappingURL=NoRowsOverlay.js.map
